// import React, { useState, useEffect, useMemo } from "react";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import Select from "react-select";
// import {
//   MapPin,
//   X,
//   Calendar as CalendarIcon,
//   ArrowRight,
//   Truck,
//   CheckCircle,
//   AlertCircle,
//   Navigation,
//   Clock,
//   User,
//   Weight
// } from "lucide-react";
// import { getAllWorkAreas } from "../services/workAreaService";
// import api from "../services/api";
// import bookingWS from "../services/bookingWebSocket"; 

// // ─── helpers ────────────────────────────────────────────────────────────────

// const formatDate = (date) => {
//   const y = date.getFullYear();
//   const m = String(date.getMonth() + 1).padStart(2, "0");
//   const d = String(date.getDate()).padStart(2, "0");
//   return `${y}-${m}-${d}`;
// };

// const formatDateTime = (date, time) => `${date} ${time}:00`;

// const haversineKm = (lat1, lng1, lat2, lng2) => {
//   const R = 6371;
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLng = ((lng2 - lng1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) ** 2 +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLng / 2) ** 2;
//   return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
// };

// const extractCoords = (raw) => {
//   if (!raw) return null;
//   const pick = (obj, keys) => {
//     for (const k of keys) {
//       if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") {
//         const n = parseFloat(obj[k]);
//         if (!Number.isNaN(n)) return n;
//       }
//     }
//     return null;
//   };
//   const latKeys = [
//     "latitude","Latitude","lat","LAT","Lat","LatitudeValue",
//     "WALatitude","WA_Latitude","WA_latitude","WaLatitude","WALat",
//     "WorkAreaLatitude","workAreaLatitude","work_area_latitude",
//   ];
//   const lngKeys = [
//     "longitude","Longitude","lng","LNG","Long","LongitudeValue",
//     "WALongitude","WA_Longitude","WA_longitude","WaLongitude","WALong",
//     "WorkAreaLongitude","workAreaLongitude","work_area_longitude",
//   ];
//   let latNum = pick(raw, latKeys);
//   let lngNum = pick(raw, lngKeys);
//   if (latNum === null || lngNum === null) {
//     const keys = Object.keys(raw || {});
//     const lk = keys.find((k) => k.toLowerCase().includes("lat"));
//     const nk = keys.find(
//       (k) =>
//         k.toLowerCase().includes("lon") ||
//         k.toLowerCase().includes("lng") ||
//         k.toLowerCase().includes("long")
//     );
//     if (latNum === null && lk) { const n = parseFloat(raw[lk]); if (!isNaN(n)) latNum = n; }
//     if (lngNum === null && nk) { const n = parseFloat(raw[nk]); if (!isNaN(n)) lngNum = n; }
//   }
//   if (latNum === null || lngNum === null) return null;
//   return { lat: latNum.toFixed(6), lng: lngNum.toFixed(6) };
// };

// // ─── component ──────────────────────────────────────────────────────────────

// export default function AdvancedBookingForm({ onBookingCreated, onClose }) {
//   const { userDetails, authKey } = useSelector((s) => s.auth);

//   const now = new Date();
//   const todayStr = formatDate(now);
 
//   const getCurrentTime = () => {
//     const hours = String(now.getHours()).padStart(2, "0");
//     const minutes = String(now.getMinutes()).padStart(2, "0");
//     return `${hours}:${minutes}`;
//   };

//   const currentTime = getCurrentTime();

//   // ── state ────────────────────────────────────────────────────────────────

//   const [selectedWeight, setSelectedWeight] = useState("");
//   const [weightOptions, setWeightOptions] = useState([]); 
//   const [loadingWeights, setLoadingWeights] = useState(false); 
//   const [forkliftVehicles, setForkliftVehicles] = useState([]);
//   const [loadingVehicles, setLoadingVehicles] = useState(false);
//   const [workAreas, setWorkAreas] = useState([]);
//   const [loadingWorkAreas, setLoadingWorkAreas] = useState(false);
//   const [driverLocation, setDriverLocation] = useState(null);

//   const [fromLocation, setFromLocation] = useState(null);
//   const [toLocation, setToLocation] = useState(null);

//   const [suggestedVehicles, setSuggestedVehicles] = useState([]);
//   const [selectedVehicle, setSelectedVehicle] = useState(null);

//   const [selectedDate, setSelectedDate] = useState(todayStr);
//   const [bsTime, setBsTime] = useState(currentTime);
//   const [timeError, setTimeError] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // Success overlay state
//   const [showBookingOverlay, setShowBookingOverlay] = useState(false);
//   const [submittedBooking, setSubmittedBooking] = useState(null);

//   // ── WebSocket Connection ─────────────────────────────────────────────────
//   useEffect(() => {
//     if (authKey) { 
//       bookingWS.connectAsEmployee(authKey);
//       console.log("[AdvancedBookingForm] Connected to booking WebSocket");
//     }
//   }, [authKey]);

//   // ── Fetch Weight Categories Dynamically ─────────────────────────────────
//   useEffect(() => {
//     const fetchWeightCategories = async () => {
//       setLoadingWeights(true);
//       try {
//         // Fetch all vehicles to get unique weight categories
//         const res = await api.get("/VehicleDetails/GetVehicleDetails");
//         let data =
//           res.data?.resultSet ??
//           res.data?.data ??
//           (Array.isArray(res.data) ? res.data : []);
         
//         const forklifts = data.filter(
//           (v) => v.vehicleType?.toLowerCase() === "forklift"
//         ); 
//         const uniqueWeights = [...new Set(forklifts.map(v => v.weightCat).filter(w => w))];
         
//         const sortOrder = ["3T", "5T", "7T", "10T", "15T", "20T", "25T", "30T"];
//         const sortedWeights = uniqueWeights.sort((a, b) => {
//           const aIndex = sortOrder.indexOf(a);
//           const bIndex = sortOrder.indexOf(b);
//           if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
//           if (aIndex !== -1) return -1;
//           if (bIndex !== -1) return 1;
//           return a.localeCompare(b);
//         });
         
//         const colorMap = {
//           "3T": "bg-blue-50 border-blue-200 text-blue-700",
//           "5T": "bg-emerald-50 border-emerald-200 text-emerald-700",
//           "7T": "bg-yellow-50 border-yellow-200 text-yellow-700",
//           "10T": "bg-orange-50 border-orange-200 text-orange-700",
//           "15T": "bg-red-50 border-red-200 text-red-700",
//           "20T": "bg-gray-100 border-gray-200 text-gray-700",
//           "25T": "bg-purple-50 border-purple-200 text-purple-700",
//           "30T": "bg-pink-50 border-pink-200 text-pink-700",
//         };
        
//         const options = sortedWeights.map(weight => ({
//           value: weight,
//           label: weight,
//           color: colorMap[weight] || "bg-gray-100 border-gray-200 text-gray-700"
//         }));
        
//         setWeightOptions(options);
//         console.log("[AdvancedBookingForm] Loaded weight categories:", options);
//       } catch (error) {
//         console.error("[AdvancedBookingForm] Failed to load weight categories:", error);
//         toast.error("Failed to load weight categories");
//       } finally {
//         setLoadingWeights(false);
//       }
//     };
    
//     fetchWeightCategories();
//   }, []);

//   // ── data fetching ─────────────────────────────────────────────────────────

//   useEffect(() => {
//     (async () => {
//       setLoadingVehicles(true);
//       try {
//         const res = await api.get("/VehicleDetails/GetVehicleDetails");
//         let data =
//           res.data?.resultSet ??
//           res.data?.data ??
//           (Array.isArray(res.data) ? res.data : []);
//         setForkliftVehicles(
//           data.filter(
//             (v) =>
//               v.vehicleType?.toLowerCase() === "forklift" &&
//               v.status?.toLowerCase() === "active"
//           )
//         );
//       } catch {
//         toast.error("Failed to load forklift vehicles");
//       } finally {
//         setLoadingVehicles(false);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     (async () => {
//       setLoadingWorkAreas(true);
//       try {
//         const data = await getAllWorkAreas();
//         setWorkAreas(
//           data.map((item) => ({
//             WAcode: item.WAcode || item.code || item.waCode,
//             WAname: item.WAname || item.name || item.waName,
//             status: item.status || item.Status,
//             raw: item,
//           }))
//         );
//       } catch {
//         toast.error("Failed to load locations");
//       } finally {
//         setLoadingWorkAreas(false);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     navigator.geolocation?.getCurrentPosition(
//       (p) => setDriverLocation({ lat: p.coords.latitude, lng: p.coords.longitude }),
//       () => {}
//     );
//   }, []);

//   // ── active work-area options ──────────────────────────────────────────────

//   const locationOptions = useMemo(() => {
//     return workAreas
//       .filter((w) => {
//         const s = String(w.status || "").trim().toLowerCase();
//         return ["active", "a", "1", "true", "yes"].includes(s);
//       })
//       .map((w) => {
//         const coords = extractCoords(w.raw);
//         return {
//           value: w.WAcode,
//           label: w.WAname,
//           raw: w.raw,
//           lat: coords ? parseFloat(coords.lat) : null,
//           lng: coords ? parseFloat(coords.lng) : null,
//         };
//       });
//   }, [workAreas]);
 
//   useEffect(() => {
//     if (!selectedWeight || !fromLocation || !toLocation) {
//       setSuggestedVehicles([]);
//       setSelectedVehicle(null);
//       return;
//     }

//     // Filter by weight category AND only online vehicles
//     const weightMatched = forkliftVehicles.filter(
//       (v) => v.weightCat === selectedWeight && v.oStatus === "Online"
//     );

//     if (weightMatched.length === 0) {
//       setSuggestedVehicles([]);
//       setSelectedVehicle(null);
//       return;
//     }

//     const fromLat = fromLocation.lat;
//     const fromLng = fromLocation.lng;

//     const sorted = [...weightMatched].sort((a, b) => {
//       if (!fromLat || !fromLng) return 0;
//       const aLat = parseFloat(a.latitude || a.lat || a.currentLat || 0);
//       const aLng = parseFloat(a.longitude || a.lng || a.currentLng || 0);
//       const bLat = parseFloat(b.latitude || b.lat || b.currentLat || 0);
//       const bLng = parseFloat(b.longitude || b.lng || b.currentLng || 0);
//       const da = aLat && aLng ? haversineKm(fromLat, fromLng, aLat, aLng) : 9999;
//       const db = bLat && bLng ? haversineKm(fromLat, fromLng, bLat, bLng) : 9999;
//       return da - db;
//     });

//     setSuggestedVehicles(sorted);
//     setSelectedVehicle(sorted[0]); // best match auto-selected
//   }, [selectedWeight, fromLocation, toLocation, forkliftVehicles]);

//   // ── time validation ───────────────────────────────────────────────────────

//   const validateTime = (time) => {
//     if (!/^([0-1]?\d|2[0-3]):[0-5]\d$/.test(time)) {
//       setTimeError("Invalid time format. Please use HH:MM");
//       return false;
//     }
//     setTimeError("");
//     return true;
//   };

//   // Helper to send WebSocket notification
//   const sendWebSocketNotification = (bookingData) => {
//     if (bookingWS.isReady()) {
//       const wsPayload = {
//         ...bookingData,
//         type: "new_booking",
//         action: "create_booking",
//         timestamp: new Date().toISOString(),
//       };
//       bookingWS.sendBooking(wsPayload);
//       console.log("[AdvancedBookingForm] 📤 WebSocket notification sent:", wsPayload);
//     } else {
//       console.warn("[AdvancedBookingForm] WebSocket not ready, notification not sent");
//     }
//   };

//   // Process booking response and send WebSocket alert
// const processBookingResponse = async (responseData, payload) => {
//   let actualBookingId = null;

//   if (responseData?.resultSet?.[0]?.bId) {
//     actualBookingId = responseData.resultSet[0].bId;
//   } else if (responseData?.result?.bId) {
//     actualBookingId = responseData.result.bId;
//   } else if (responseData?.bId) {
//     actualBookingId = responseData.bId;
//   } else if (responseData?.id) {
//     actualBookingId = responseData.id;
//   }

//   // ✅ bId නැත්නම් API එකෙන් fetch කරන්න
//   if (!actualBookingId) {
//     try {
//       console.log("[AdvancedBookingForm] bId missing from response, fetching from API...");
//       const bookingsRes = await api.get("/BookingDetails/GetBookingDetails");
//       const allBookings = bookingsRes.data?.resultSet || [];
      
//       // Most recent pending booking for this vehicle+driver
//       const matched = allBookings
//         .filter(b =>
//           b.vId === payload[0].vId &&
//           b.dSNo === payload[0].dSNo &&
//           (b.status === "P" || b.status === "Pending")
//         )
//         .sort((a, b) => parseInt(b.bId) - parseInt(a.bId))[0];

//       if (matched?.bId) {
//         actualBookingId = matched.bId;
//         console.log("[AdvancedBookingForm] ✅ Fetched bId from API:", actualBookingId);
//       }
//     } catch (err) {
//       console.warn("[AdvancedBookingForm] Failed to fetch bId:", err);
//     }
//   }

//   const bookingForAlert = {
//     bId: actualBookingId,        // ✅ actual bId
//     vId: payload[0].vId,
//     dSNo: payload[0].dSNo,
//     employeeName: userDetails?.Name || "Employee",
//     slatitude: payload[0].slatitude,
//     slongitude: payload[0].slongitude,
//     elatitude: payload[0].elatitude,
//     elongitude: payload[0].elongitude,
//     totalDestence: "0",
//     bookingDT: payload[0].bookingDT,
//     status: "P",
//     bookingSno: userDetails?.ServiceNo || "",
//     dlatitude: payload[0].dlatitude,
//     dlongitude: payload[0].dlongitude,
//     From: payload[0].From,
//     TO: payload[0].TO,
//     vehicleType: "Forklift",
//     weightCat: selectedWeight,
//   };

//   sendWebSocketNotification(bookingForAlert);
//   return { actualBookingId, bookingForAlert };
// };

//   // ── submit ────────────────────────────────────────────────────────────────

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedWeight)  { toast.error("Please select weight category."); return; }
//     if (!fromLocation)    { toast.error("Please select From location."); return; }
//     if (!toLocation)      { toast.error("Please select To location."); return; }
//     if (!selectedVehicle) { toast.error("No vehicle available for this selection."); return; }
//     if (!bsTime)          { toast.error("Please select start time."); return; }

//     const fromCoords = extractCoords(fromLocation.raw);
//     const toCoords   = extractCoords(toLocation.raw);
//     if (!fromCoords) { toast.error("From location coordinates are missing."); return; }
//     if (!toCoords)   { toast.error("To location coordinates are missing."); return; }

//     setIsSubmitting(true);
//     try {
//       const bookingDateTime = formatDateTime(selectedDate, bsTime);
//       const payload = [{
//         bId: "",
//         vId: selectedVehicle.vehicleId,
//         dSNo: selectedVehicle.driverSno,
//         slatitude:  fromCoords.lat,
//         slongitude: fromCoords.lng,
//         elatitude:  toCoords.lat,
//         elongitude: toCoords.lng,
//         status: "P",
//         bookingDT: bookingDateTime,
//         bsTime: bookingDateTime,
//         beTime: null,
//         totalDestence: "0",
//         dlongitude: String(driverLocation?.lng || fromCoords.lng),
//         dlatitude:  String(driverLocation?.lat || fromCoords.lat),
//         bookingSno: userDetails?.ServiceNo || "",
//         WorkArea: null, WorkScope: null, Priority: null,
//         From: fromLocation.value,
//         TO:   toLocation.value,
//         Remark: "",
//         SubBook: "I",
//         BookingStatus: "R",
//       }];

//       console.log("[AdvancedBookingForm] 📤 Sending booking payload:", JSON.stringify(payload, null, 2));

//       const res = await api.post("/BookingRegister/PostForkBooking", payload);
      
// if (res.status === 200) {
//   const { bookingForAlert, actualBookingId } = await processBookingResponse(res.data, payload);
 
//   console.log("[AdvancedBookingForm] Actual bId from API:", actualBookingId);
        
//         // Get driver name for display
//         let driverName = selectedVehicle.driverName || selectedVehicle.driverSno || "Driver";
//         try {
//           // Optional: Fetch driver name from users API
//           const usersRes = await api.get("/User/GetUsers");
//           const users = usersRes.data?.resultSet || usersRes.data || [];
//           const driver = users.find(u => u.ServiceNo === selectedVehicle.driverSno);
//           if (driver?.Name) driverName = driver.Name;
//         } catch (err) {
//           console.warn("Failed to fetch driver name:", err);
//         }
        
//         // Set submitted booking for success overlay
//         setSubmittedBooking({
//           ...bookingForAlert,
//           vehicleType: "Forklift",
//           driverName: driverName,
//           weightCat: selectedWeight,
//           distance: "0",
//         });
        
//         setShowBookingOverlay(true);
//         toast.success("Forklift booking created successfully!");
        
//         if (onBookingCreated) await onBookingCreated();
        
//         // Auto-close after 3 seconds
//         setTimeout(() => {
//           setShowBookingOverlay(false);
//           if (onClose) onClose();
//         }, 3000);
//       }
//     } catch (err) {
//       console.error("[AdvancedBookingForm] Booking failed:", err);
//       toast.error("Failed to create booking. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
  
//   // ── step visibility ───────────────────────────────────────────────────────

//   const showStep2 = !!selectedWeight;
//   const showStep3 = showStep2 && !!fromLocation && !!toLocation;
//   const showStep4 = showStep3 && !!selectedVehicle;

//   const selectPortalStyles = {
//     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//     menu:       (base) => ({ ...base, zIndex: 9999 }),
//   };

//   // Get color classes for weight card
//   const getWeightCardColors = (color) => {
//     const colors = {
//       blue: "bg-blue-50 border-blue-200 text-blue-700",
//       green: "bg-emerald-50 border-emerald-200 text-emerald-700",
//       yellow: "bg-yellow-50 border-yellow-200 text-yellow-700",
//       orange: "bg-orange-50 border-orange-200 text-orange-700",
//       red: "bg-red-50 border-red-200 text-red-700",
//       gray: "bg-gray-100 border-gray-200 text-gray-700",
//       purple: "bg-purple-50 border-purple-200 text-purple-700",
//       pink: "bg-pink-50 border-pink-200 text-pink-700",
//     };
//     return colors[color] || colors.gray;
//   };

//   // ─────────────────────────────────────────────────────────────────────────

//   return (
//     <>
//       <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gray-50">
//           <div className="flex items-center gap-2">
//             <div className="p-1.5 bg-blue-50 rounded-lg">
//               <Truck size={16} className="text-blue-600" />
//             </div>
//             <h2 className="text-base font-semibold text-gray-900">Create Forklift Booking</h2>
//           </div>
//           {onClose && (
//             <button
//               onClick={onClose}
//               className="p-1 hover:bg-gray-100 rounded-lg transition"
//             >
//               <X size={16} className="text-gray-400" />
//             </button>
//           )}
//         </div>

//         <form onSubmit={handleSubmit} className="p-4 space-y-5">

//           {/* ── STEP 1: Weight Category ── */}
//           <div className="space-y-3">
//             <div className="flex items-center gap-2">
//               <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-900 text-white font-bold text-xs">
//                 1
//               </div>
//               <h3 className="text-sm font-semibold text-gray-900">Select Weight Category</h3>
//             </div>

//             {loadingWeights || loadingVehicles ? (
//               <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
//                 <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-900 rounded-full animate-spin" />
//                 <span className="text-xs text-gray-500">Loading weight categories...</span>
//               </div>
//             ) : weightOptions.length === 0 ? (
//               <div className="text-center py-4 bg-yellow-50 rounded-lg border border-yellow-200">
//                 <AlertCircle size={16} className="mx-auto text-yellow-600 mb-1" />
//                 <p className="text-xs text-yellow-700">No weight categories available. Please check vehicle data.</p>
//               </div>
//             ) : (
//               <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
//                 {weightOptions.map((opt) => {
//                   const count = forkliftVehicles.filter(
//                     (v) => v.weightCat === opt.value && v.oStatus === "Online"
//                   ).length;
//                   const active = selectedWeight === opt.value;
                  
//                   // Extract color from opt.color class string
//                   const colorClass = opt.color;
//                   let colorKey = "gray";
//                   if (colorClass.includes("blue")) colorKey = "blue";
//                   else if (colorClass.includes("emerald")) colorKey = "green";
//                   else if (colorClass.includes("yellow")) colorKey = "yellow";
//                   else if (colorClass.includes("orange")) colorKey = "orange";
//                   else if (colorClass.includes("red")) colorKey = "red";
//                   else if (colorClass.includes("purple")) colorKey = "purple";
//                   else if (colorClass.includes("pink")) colorKey = "pink";
                  
//                   // Don't show card if count is 0
//                   if (count === 0) return null;
                  
//                   return (
//                     <button
//                       key={opt.value}
//                       type="button"
//                       onClick={() => {
//                         setSelectedWeight(opt.value);
//                         setFromLocation(null);
//                         setToLocation(null);
//                         setSuggestedVehicles([]);
//                         setSelectedVehicle(null);
//                       }}
//                       className={`relative flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-all ${
//                         active
//                           ? `${getWeightCardColors(colorKey)} ring-2 ring-offset-1 ring-gray-400 shadow-sm`
//                           : `${getWeightCardColors(colorKey)} hover:shadow-md cursor-pointer`
//                       }`}
//                     >
//                       <Weight size={16} className="mb-1" />
//                       <span className="text-xs font-semibold">{opt.label}</span>
//                       <span className="text-[10px] mt-0.5 opacity-70">
//                         {count} avail
//                       </span>
//                       {active && (
//                         <CheckCircle size={12} className="absolute top-1 right-1 text-gray-600" />
//                       )}
//                     </button>
//                   );
//                 })}
//               </div>
//             )}
//             {!loadingWeights && !loadingVehicles && weightOptions.length > 0 && weightOptions.filter(opt => forkliftVehicles.filter(v => v.weightCat === opt.value && v.oStatus === "Online").length > 0).length === 0 && (
//               <div className="text-center py-4 bg-yellow-50 rounded-lg border border-yellow-200">
//                 <AlertCircle size={16} className="mx-auto text-yellow-600 mb-1" />
//                 <p className="text-xs text-yellow-700">No forklifts available online for any weight category</p>
//               </div>
//             )}
//           </div>

//           {/* ── STEP 2: Locations ── */}
//           {showStep2 && (
//             <div className="space-y-4 pt-2 border-t border-gray-100">
//               <div className="flex items-center gap-2">
//                 <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-900 text-white font-bold text-xs">
//                   2
//                 </div>
//                 <h3 className="text-sm font-semibold text-gray-900">Select Locations</h3>
//               </div>

//               {loadingWorkAreas ? (
//                 <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
//                   <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-900 rounded-full animate-spin" />
//                   <span className="text-xs text-gray-500">Loading locations...</span>
//                 </div>
//               ) : (
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                   {/* From */}
//                   <div>
//                     <label className="block text-xs font-medium text-gray-700 mb-1.5 flex items-center gap-1.5">
//                       <MapPin size={12} className="text-emerald-600" />
//                       From Location <span className="text-red-500">*</span>
//                     </label>
//                     <Select
//                       options={locationOptions}
//                       value={fromLocation}
//                       onChange={(opt) => {
//                         setFromLocation(opt);
//                         setSelectedVehicle(null);
//                       }}
//                       placeholder="Select starting location..."
//                       isClearable
//                       isSearchable
//                       menuPortalTarget={document.body}
//                       styles={selectPortalStyles}
//                       className="text-sm"
//                       classNamePrefix="react-select"
//                     />
//                   </div>

//                   {/* To */}
//                   <div>
//                     <label className="block text-xs font-medium text-gray-700 mb-1.5 flex items-center gap-1.5">
//                       <MapPin size={12} className="text-red-600" />
//                       To Location <span className="text-red-500">*</span>
//                     </label>
//                     <Select
//                       options={locationOptions.filter(
//                         (o) => o.value !== fromLocation?.value
//                       )}
//                       value={toLocation}
//                       onChange={(opt) => {
//                         setToLocation(opt);
//                         setSelectedVehicle(null);
//                       }}
//                       placeholder="Select destination..."
//                       isClearable
//                       isSearchable
//                       menuPortalTarget={document.body}
//                       styles={selectPortalStyles}
//                       className="text-sm"
//                       classNamePrefix="react-select"
//                     />
//                   </div>
//                 </div>
//               )}

//               {fromLocation && toLocation && (
//                 <div className="flex items-center justify-center gap-2 p-2 bg-gray-50 rounded-lg">
//                   <span className="text-xs font-medium text-gray-600 truncate">{fromLocation.label}</span>
//                   <ArrowRight size={12} className="text-gray-400" />
//                   <span className="text-xs font-medium text-gray-600 truncate">{toLocation.label}</span>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ── STEP 3: Suggested Vehicle ── */}
//           {showStep3 && (
//             <div className="space-y-3 pt-2 border-t border-gray-100">
//               <div className="flex items-center gap-2">
//                 <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-900 text-white font-bold text-xs">
//                   3
//                 </div>
//                 <h3 className="text-sm font-semibold text-gray-900">Suggested Forklift</h3>
//               </div>

//               {suggestedVehicles.length === 0 ? (
//                 <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
//                   <div className="flex items-center gap-2">
//                     <AlertCircle size={14} className="text-yellow-600" />
//                     <p className="text-xs text-yellow-700">
//                       No <strong>{selectedWeight}</strong> forklift available online. Please choose a different weight category.
//                     </p>
//                   </div>
//                 </div>
//               ) : (
//                 <>
//                   <p className="text-[10px] text-gray-500">
//                     Best available <strong>{selectedWeight}</strong> forklift closest to <strong>{fromLocation?.label}</strong>
//                   </p>
//                   <div className="space-y-2">
//                     {(() => {
//                       const v = suggestedVehicles[0];
//                       const isSelected = selectedVehicle?.vehicleId === v.vehicleId;
//                       const vLat = parseFloat(v.latitude || v.lat || v.currentLat || 0);
//                       const vLng = parseFloat(v.longitude || v.lng || v.currentLng || 0);
//                       const dist = fromLocation?.lat && fromLocation?.lng && vLat && vLng
//                         ? haversineKm(fromLocation.lat, fromLocation.lng, vLat, vLng).toFixed(1)
//                         : null;

//                       return (
//                         <button
//                           key={v.vehicleId}
//                           type="button"
//                           onClick={() => setSelectedVehicle(v)}
//                           className={`w-full flex items-center justify-between p-3 rounded-lg border-2 transition-all ${
//                             isSelected
//                               ? "border-emerald-500 bg-emerald-50"
//                               : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50"
//                           }`}
//                         >
//                           <div className="flex items-center gap-3">
//                             <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center">
//                               <Navigation size={14} className="text-amber-600" />
//                             </div>
//                             <div className="text-left">
//                               <p className="text-sm font-semibold text-gray-900">{v.vehicleId}</p>
//                               <div className="flex items-center gap-2 text-xs text-gray-500 mt-0.5">
//                                 <span>{v.weightCat}</span>
//                                 <span>•</span>
//                                 <div className="flex items-center gap-1">
//                                   <User size={10} />
//                                   <span>{v.driverSno}</span>
//                                 </div>
//                                 {dist && (
//                                   <>
//                                     <span>•</span>
//                                     <span>~{dist} km away</span>
//                                   </>
//                                 )}
//                               </div>
//                             </div>
//                           </div>
//                           <div className="flex items-center gap-2">
//                             <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium bg-emerald-50 text-emerald-700">
//                               Online
//                             </span>
//                             {isSelected && <CheckCircle size={14} className="text-emerald-600" />}
//                           </div>
//                         </button>
//                       );
//                     })()}
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ── STEP 4: Schedule ── */}
//           {showStep4 && (
//             <div className="space-y-3 pt-2 border-t border-gray-100">
//               <div className="flex items-center gap-2">
//                 <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-900 text-white font-bold text-xs">
//                   4
//                 </div>
//                 <h3 className="text-sm font-semibold text-gray-900">Schedule Booking</h3>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                 <div>
//                   <label className="block text-xs font-medium text-gray-700 mb-1.5 flex items-center gap-1.5">
//                     <CalendarIcon size={12} className="text-blue-600" />
//                     Booking Date <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="date"
//                     value={selectedDate}
//                     disabled
//                     className="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg bg-gray-50 text-gray-500 cursor-not-allowed"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-xs font-medium text-gray-700 mb-1.5 flex items-center gap-1.5">
//                     <Clock size={12} className="text-blue-600" />
//                     Start Time <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     value={bsTime}
//                     disabled
//                     className="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg bg-gray-50 text-gray-500 cursor-not-allowed"
//                   />
//                   <p className="text-[10px] text-gray-400 mt-1">Current time (automatically set)</p>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ── Summary ── */}
//           {showStep4 && bsTime && (
//             <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
//               <h4 className="text-xs font-semibold text-gray-700 mb-2">Booking Summary</h4>
//               <div className="grid grid-cols-2 gap-2 text-xs">
//                 <div>
//                   <span className="text-gray-500">Vehicle:</span>
//                   <p className="font-semibold text-gray-900">{selectedVehicle.vehicleId}</p>
//                 </div>
//                 <div>
//                   <span className="text-gray-500">Capacity:</span>
//                   <p className="text-gray-900">{selectedVehicle.weightCat}</p>
//                 </div>
//                 <div>
//                   <span className="text-gray-500">Driver:</span>
//                   <p className="text-gray-900">{selectedVehicle.driverSno}</p>
//                 </div>
//                 <div>
//                   <span className="text-gray-500">Date & Time:</span>
//                   <p className="font-semibold text-gray-900">{selectedDate} {bsTime}</p>
//                 </div>
//                 <div className="col-span-2">
//                   <span className="text-gray-500">Route:</span>
//                   <p className="text-gray-900 flex items-center gap-1 flex-wrap mt-0.5">
//                     <span>{fromLocation.label}</span>
//                     <ArrowRight size={10} />
//                     <span>{toLocation.label}</span>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ── Buttons ── */}
//           <div className="flex gap-3 pt-2 border-t border-gray-100">
//             {onClose && (
//               <button
//                 type="button"
//                 onClick={onClose}
//                 className="flex-1 px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
//               >
//                 Cancel
//               </button>
//             )}
//             <button
//               type="submit"
//               disabled={!showStep4 || !bsTime || isSubmitting}
//               className={`flex-1 px-3 py-1.5 text-sm font-medium rounded-lg transition ${
//                 showStep4 && bsTime && !isSubmitting
//                   ? "bg-emerald-600 text-white hover:bg-emerald-700"
//                   : "bg-gray-200 text-gray-400 cursor-not-allowed"
//               }`}
//             >
//               {isSubmitting ? (
//                 <div className="flex items-center justify-center gap-1.5">
//                   <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                   Creating...
//                 </div>
//               ) : (
//                 "Create Forklift Booking"
//               )}
//             </button>
//           </div>
//         </form>
//       </div>

//       {/* Booking Success Overlay */}
//       {showBookingOverlay && submittedBooking && (
//         <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center px-4 z-50">
//           <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-5 relative">
//             {/* Close button */}
//             <button
//               onClick={() => {
//                 setShowBookingOverlay(false);
//                 if (onClose) onClose();
//               }}
//               className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
//             >
//               <X size={16} />
//             </button>

//             {/* Success Icon */}
//             <div className="flex justify-center mb-3">
//               <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
//                 <CheckCircle size={24} className="text-green-600" />
//               </div>
//             </div>

//             {/* Title */}
//             <h2 className="text-lg font-bold text-center text-gray-800 mb-1">
//               Forklift Booking Request Sent!
//             </h2>
//             <p className="text-center text-xs text-gray-500 mb-4">
//               Waiting for driver acceptance...
//             </p>

//             {/* Booking Details */}
//             <div className="bg-gray-50 rounded-lg p-3 space-y-2 mb-4">
//               <div className="flex justify-between items-center">
//                 <span className="text-xs text-gray-500">Booking ID:</span>
//                 <span className="font-semibold text-blue-700 text-sm">
//                   #{submittedBooking.bId || "Pending"}
//                 </span>
//               </div>
//               <div className="flex justify-between items-center">
//                 <span className="text-xs text-gray-500">Vehicle:</span>
//                 <span className="font-medium text-gray-800 text-sm">
//                   Forklift ({submittedBooking.weightCat})
//                 </span>
//               </div>
//               <div className="flex justify-between items-center">
//                 <span className="text-xs text-gray-500">Driver:</span>
//                 <span className="font-medium text-gray-800 text-sm">
//                   {submittedBooking.driverName}
//                 </span>
//               </div>
//               <div className="flex justify-between items-center">
//                 <span className="text-xs text-gray-500">Route:</span>
//                 <span className="font-medium text-gray-800 text-sm truncate max-w-[180px]">
//                   {submittedBooking.From} → {submittedBooking.TO}
//                 </span>
//               </div>
//             </div>

//             {/* Loading Animation */}
//             <div className="flex justify-center items-center space-x-1.5 mb-3">
//               <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: "0s" }}></div>
//               <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: "0.2s" }}></div>
//               <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: "0.4s" }}></div>
//             </div>

//             {/* Auto-redirect message */}
//             <p className="text-center text-[10px] text-gray-400">
//               Closing in a moment...
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }


import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";
import CustomTimePicker from "../components/CustomTimePicker";
import {
  MapPin,
  X,
  Calendar as CalendarIcon,
  ArrowRight,
  Truck,
  CheckCircle,
} from "lucide-react";
import { getAllWorkAreas } from "../services/workAreaService";
import api from "../services/api";
import bookingWS from "../services/bookingWebSocket";

// ─── helpers ────────────────────────────────────────────────────────────────

const formatDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const formatDateTime = (date, time) => `${date} ${time}:00`;

const haversineKm = (lat1, lng1, lat2, lng2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

const extractCoords = (raw) => {
  if (!raw) return null;
  const pick = (obj, keys) => {
    for (const k of keys) {
      if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") {
        const n = parseFloat(obj[k]);
        if (!Number.isNaN(n)) return n;
      }
    }
    return null;
  };
  const latKeys = [
    "latitude","Latitude","lat","LAT","Lat","LatitudeValue",
    "WALatitude","WA_Latitude","WA_latitude","WaLatitude","WALat",
    "WorkAreaLatitude","workAreaLatitude","work_area_latitude",
  ];
  const lngKeys = [
    "longitude","Longitude","lng","LNG","Long","LongitudeValue",
    "WALongitude","WA_Longitude","WA_longitude","WaLongitude","WALong",
    "WorkAreaLongitude","workAreaLongitude","work_area_longitude",
  ];
  let latNum = pick(raw, latKeys);
  let lngNum = pick(raw, lngKeys);
  if (latNum === null || lngNum === null) {
    const keys = Object.keys(raw || {});
    const lk = keys.find((k) => k.toLowerCase().includes("lat"));
    const nk = keys.find(
      (k) =>
        k.toLowerCase().includes("lon") ||
        k.toLowerCase().includes("lng") ||
        k.toLowerCase().includes("long")
    );
    if (latNum === null && lk) { const n = parseFloat(raw[lk]); if (!isNaN(n)) latNum = n; }
    if (lngNum === null && nk) { const n = parseFloat(raw[nk]); if (!isNaN(n)) lngNum = n; }
  }
  if (latNum === null || lngNum === null) return null;
  return { lat: latNum.toFixed(6), lng: lngNum.toFixed(6) };
};

// ─── component ──────────────────────────────────────────────────────────────

export default function AdvancedBookingForm({ onBookingCreated, onClose }) {
  const { userDetails, authKey } = useSelector((s) => s.auth);

  const now = new Date();
  const todayStr = formatDate(now);
 
  const getCurrentTime = () => {
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const currentTime = getCurrentTime();

  // ── state ────────────────────────────────────────────────────────────────

  const [selectedWeight, setSelectedWeight] = useState("");
  const [weightOptions, setWeightOptions] = useState([]); 
  const [loadingWeights, setLoadingWeights] = useState(false); 
  const [forkliftVehicles, setForkliftVehicles] = useState([]);
  const [loadingVehicles, setLoadingVehicles] = useState(false);
  const [workAreas, setWorkAreas] = useState([]);
  const [loadingWorkAreas, setLoadingWorkAreas] = useState(false);
  const [driverLocation, setDriverLocation] = useState(null);

  const [fromLocation, setFromLocation] = useState(null);
  const [toLocation, setToLocation] = useState(null);

  const [suggestedVehicles, setSuggestedVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const [selectedDate, setSelectedDate] = useState(todayStr);
  const [bsTime, setBsTime] = useState(currentTime);
  const [timeError, setTimeError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Success overlay state
  const [showBookingOverlay, setShowBookingOverlay] = useState(false);
  const [submittedBooking, setSubmittedBooking] = useState(null);

  // ── WebSocket Connection ─────────────────────────────────────────────────
  useEffect(() => {
    if (authKey) { 
      bookingWS.connectAsEmployee(authKey);
      console.log("[AdvancedBookingForm] Connected to booking WebSocket");
    }
  }, [authKey]);

  // ── Fetch Weight Categories Dynamically ─────────────────────────────────
  useEffect(() => {
    const fetchWeightCategories = async () => {
      setLoadingWeights(true);
      try {
        const res = await api.get("/VehicleDetails/GetVehicleDetails");
        let data =
          res.data?.resultSet ??
          res.data?.data ??
          (Array.isArray(res.data) ? res.data : []);
         
        const forklifts = data.filter(
          (v) => v.vehicleType?.toLowerCase() === "forklift"
        ); 
        const uniqueWeights = [...new Set(forklifts.map(v => v.weightCat).filter(w => w))];
         
        const sortOrder = ["3T", "5T", "7T", "10T", "15T", "20T", "25T", "30T"];
        const sortedWeights = uniqueWeights.sort((a, b) => {
          const aIndex = sortOrder.indexOf(a);
          const bIndex = sortOrder.indexOf(b);
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;
          return a.localeCompare(b);
        });
         
        const colorMap = {
          "3T": "bg-blue-100 text-blue-700 border-blue-300",
          "5T": "bg-green-100 text-green-700 border-green-300",
          "7T": "bg-yellow-100 text-yellow-700 border-yellow-300",
          "10T": "bg-orange-100 text-orange-700 border-orange-300",
          "15T": "bg-red-100 text-red-700 border-red-300",
          "20T": "bg-gray-200 text-gray-700 border-gray-400",
          "25T": "bg-purple-100 text-purple-700 border-purple-300",
          "30T": "bg-pink-100 text-pink-700 border-pink-300",
        };
        
        const options = sortedWeights.map(weight => ({
          value: weight,
          label: weight,
          color: colorMap[weight] || "bg-gray-100 text-gray-700 border-gray-300"
        }));
        
        setWeightOptions(options);
        console.log("[AdvancedBookingForm] Loaded weight categories:", options);
      } catch (error) {
        console.error("[AdvancedBookingForm] Failed to load weight categories:", error);
        toast.error("Failed to load weight categories");
      } finally {
        setLoadingWeights(false);
      }
    };
    
    fetchWeightCategories();
  }, []);

  // ── data fetching ─────────────────────────────────────────────────────────

  useEffect(() => {
    (async () => {
      setLoadingVehicles(true);
      try {
        const res = await api.get("/VehicleDetails/GetVehicleDetails");
        let data =
          res.data?.resultSet ??
          res.data?.data ??
          (Array.isArray(res.data) ? res.data : []);
        setForkliftVehicles(
          data.filter(
            (v) =>
              v.vehicleType?.toLowerCase() === "forklift" &&
              v.status?.toLowerCase() === "active"
          )
        );
      } catch {
        toast.error("Failed to load forklift vehicles");
      } finally {
        setLoadingVehicles(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoadingWorkAreas(true);
      try {
        const data = await getAllWorkAreas();
        setWorkAreas(
          data.map((item) => ({
            WAcode: item.WAcode || item.code || item.waCode,
            WAname: item.WAname || item.name || item.waName,
            status: item.status || item.Status,
            raw: item,
          }))
        );
      } catch {
        toast.error("Failed to load locations");
      } finally {
        setLoadingWorkAreas(false);
      }
    })();
  }, []);

  useEffect(() => {
    navigator.geolocation?.getCurrentPosition(
      (p) => setDriverLocation({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => {}
    );
  }, []);

  // ── active work-area options ──────────────────────────────────────────────

  const locationOptions = useMemo(() => {
    return workAreas
      .filter((w) => {
        const s = String(w.status || "").trim().toLowerCase();
        return ["active", "a", "1", "true", "yes"].includes(s);
      })
      .map((w) => {
        const coords = extractCoords(w.raw);
        return {
          value: w.WAcode,
          label: w.WAname,
          raw: w.raw,
          lat: coords ? parseFloat(coords.lat) : null,
          lng: coords ? parseFloat(coords.lng) : null,
        };
      });
  }, [workAreas]);
 
  useEffect(() => {
    if (!selectedWeight || !fromLocation || !toLocation) {
      setSuggestedVehicles([]);
      setSelectedVehicle(null);
      return;
    }

    const weightMatched = forkliftVehicles.filter(
      (v) => v.weightCat === selectedWeight && v.oStatus === "Online"
    );

    if (weightMatched.length === 0) {
      setSuggestedVehicles([]);
      setSelectedVehicle(null);
      return;
    }

    const fromLat = fromLocation.lat;
    const fromLng = fromLocation.lng;

    const sorted = [...weightMatched].sort((a, b) => {
      if (!fromLat || !fromLng) return 0;
      const aLat = parseFloat(a.latitude || a.lat || a.currentLat || 0);
      const aLng = parseFloat(a.longitude || a.lng || a.currentLng || 0);
      const bLat = parseFloat(b.latitude || b.lat || b.currentLat || 0);
      const bLng = parseFloat(b.longitude || b.lng || b.currentLng || 0);
      const da = aLat && aLng ? haversineKm(fromLat, fromLng, aLat, aLng) : 9999;
      const db = bLat && bLng ? haversineKm(fromLat, fromLng, bLat, bLng) : 9999;
      return da - db;
    });

    setSuggestedVehicles(sorted);
    setSelectedVehicle(sorted[0]);
  }, [selectedWeight, fromLocation, toLocation, forkliftVehicles]);

  // ── time validation ───────────────────────────────────────────────────────

  const validateTime = (time) => {
    if (!/^([0-1]?\d|2[0-3]):[0-5]\d$/.test(time)) {
      setTimeError("Invalid time format. Please use HH:MM");
      return false;
    }
    setTimeError("");
    return true;
  };

  const handleTimeChange = (newTime) => {
    setBsTime(newTime);
    if (validateTime(newTime)) {
      console.log("[AdvancedBookingForm] Time updated to:", newTime);
    }
  };

  // ✅ FIXED: Schedule WebSocket notification for the future (not immediate)
  const scheduleWebSocketNotification = (bookingData, scheduledDateTime) => {
    const scheduledTime = new Date(scheduledDateTime);
    const now = new Date();
    const delayMs = scheduledTime.getTime() - now.getTime();
    
    console.log(`[AdvancedBookingForm] 📅 Scheduling alert for: ${scheduledDateTime}`);
    console.log(`[AdvancedBookingForm] ⏰ Delay: ${Math.floor(delayMs / 1000)} seconds`);
    
    if (delayMs <= 0) {
      // If time is in past, send immediately
      console.warn("[AdvancedBookingForm] ⚠️ Scheduled time is in the past, sending immediately");
      sendWebSocketNotification(bookingData, scheduledDateTime);
      return;
    }
    
    // Schedule the notification for the future
    setTimeout(() => {
      console.log(`[AdvancedBookingForm] 🔔 Time reached! Sending alert for booking at ${scheduledDateTime}`);
      sendWebSocketNotification(bookingData, scheduledDateTime);
    }, delayMs);
    
    toast.info(`📅 Booking scheduled for ${scheduledDateTime}. Driver will be notified at that time.`);
  };

  // Send WebSocket notification (called only when scheduled time arrives)
  const sendWebSocketNotification = (bookingData, scheduledDateTime) => {
    if (!scheduledDateTime) {
      console.error("[AdvancedBookingForm] ❌ Missing scheduled time");
      return;
    }

    console.log("[AdvancedBookingForm] 📤 Sending booking alert to driver for:", scheduledDateTime);
    
    toast.info(`🔔 Booking alert sent to driver for ${scheduledDateTime}`);
    
    _doSendWS(bookingData, scheduledDateTime);
  };

  // Helper - actual WS send logic with retry
  const _doSendWS = (bookingData, scheduledDateTime, retryCount = 0) => {
    if (bookingWS.isReady()) {
      const wsPayload = {
        ...bookingData,
        type: "new_booking",
        action: "create_booking",
        timestamp: new Date().toISOString(),
        bookingTime: scheduledDateTime,
        // Important: Mark as scheduled booking
        BookingStatus: "S", // S = Scheduled Booking
        isScheduled: true,
        scheduledFor: scheduledDateTime,
      };
      const sent = bookingWS.sendBooking(wsPayload);
      if (sent) {
        console.log("[AdvancedBookingForm] ✅ WS notification sent at:", new Date().toISOString());
      } else {
        console.warn("[AdvancedBookingForm] ⚠️ Failed to send WS notification");
      }
    } else if (retryCount < 3) {
      console.warn(`[AdvancedBookingForm] ⚠️ WebSocket not ready - retry ${retryCount + 1}/3 in 1s...`);
      setTimeout(() => {
        _doSendWS(bookingData, scheduledDateTime, retryCount + 1);
      }, 1000 * (retryCount + 1));
    } else {
      console.error("[AdvancedBookingForm] ❌ WebSocket still not ready after 3 retries - notification failed");
      toast.error("Failed to send alert to driver. Driver may not receive notification immediately.");
    }
  };

  const processBookingResponse = async (responseData, payload, bookingDateTime) => {
    if (!bookingDateTime) {
      console.error("[AdvancedBookingForm] ❌ Missing bookingDateTime in processBookingResponse");
      throw new Error("Booking date time is required");
    }
    
    let actualBookingId = null;

    if (responseData?.resultSet?.[0]?.bId) {
      actualBookingId = responseData.resultSet[0].bId;
    } else if (responseData?.result?.bId) {
      actualBookingId = responseData.result.bId;
    } else if (responseData?.bId) {
      actualBookingId = responseData.bId;
    } else if (responseData?.id) {
      actualBookingId = responseData.id;
    }

    if (!actualBookingId) {
      try {
        console.log("[AdvancedBookingForm] bId missing from response, fetching from API...");
        const bookingsRes = await api.get("/BookingDetails/GetBookingDetails");
        const allBookings = bookingsRes.data?.resultSet || [];
        
        const matched = allBookings
          .filter(b =>
            b.vId === payload[0].vId &&
            b.dSNo === payload[0].dSNo &&
            (b.status === "P" || b.status === "Pending")
          )
          .sort((a, b) => parseInt(b.bId) - parseInt(a.bId))[0];

        if (matched?.bId) {
          actualBookingId = matched.bId;
          console.log("[AdvancedBookingForm] ✅ Fetched bId from API:", actualBookingId);
        }
      } catch (err) {
        console.warn("[AdvancedBookingForm] Failed to fetch bId:", err);
      }
    }

    const bookingForAlert = {
      bId: actualBookingId,
      vId: payload[0].vId,
      dSNo: payload[0].dSNo,
      employeeName: userDetails?.Name || "Employee",
      slatitude: payload[0].slatitude,
      slongitude: payload[0].slongitude,
      elatitude: payload[0].elatitude,
      elongitude: payload[0].elongitude,
      totalDestence: "0",
      bookingDT: bookingDateTime,
      bsTime: bookingDateTime, // Scheduled start time
      beTime: null,
      status: "P",
      bookingSno: userDetails?.ServiceNo || "",
      dlatitude: payload[0].dlatitude,
      dlongitude: payload[0].dlongitude,
      From: payload[0].From,
      TO: payload[0].TO,
      vehicleType: "Forklift",
      weightCat: selectedWeight,
      BookingStatus: "S", // S = Scheduled Booking
      isScheduled: true,
    };

    // ✅ Schedule notification for the future (not immediate)
    if (bookingDateTime) {
      scheduleWebSocketNotification(bookingForAlert, bookingDateTime);
    } else {
      console.error("[AdvancedBookingForm] ❌ Skipping WebSocket notification: Invalid booking time");
    }
    
    return { actualBookingId, bookingForAlert };
  };

  // ── submit ────────────────────────────────────────────────────────────────

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedWeight)  { toast.error("Please select weight category."); return; }
    if (!fromLocation)    { toast.error("Please select From location."); return; }
    if (!toLocation)      { toast.error("Please select To location."); return; }
    if (!selectedVehicle) { toast.error("No vehicle available for this selection."); return; }
    if (!bsTime)          { toast.error("Please select start time."); return; }
    
    // Validate time format
    if (!validateTime(bsTime)) {
      toast.error("Please enter a valid time in HH:MM format");
      return;
    }

    const fromCoords = extractCoords(fromLocation.raw);
    const toCoords   = extractCoords(toLocation.raw);
    if (!fromCoords) { toast.error("From location coordinates are missing."); return; }
    if (!toCoords)   { toast.error("To location coordinates are missing."); return; }

    setIsSubmitting(true);
    try {
      const bookingDateTime = formatDateTime(selectedDate, bsTime);
      console.log("[AdvancedBookingForm] Scheduled booking date time:", bookingDateTime);
      
      // Check if selected time is in the future
      const selectedTime = new Date(bookingDateTime);
      const now = new Date();
      if (selectedTime <= now) {
        toast.warning("Selected time is in the past. Booking will be sent immediately.");
      }
      
      const payload = [{
        bId: "",
        vId: selectedVehicle.vehicleId,
        dSNo: selectedVehicle.driverSno,
        slatitude:  fromCoords.lat,
        slongitude: fromCoords.lng,
        elatitude:  toCoords.lat,
        elongitude: toCoords.lng,
        status: "P",
        bookingDT: bookingDateTime,
        bsTime: bookingDateTime, // Scheduled start time
        beTime: null,
        totalDestence: "0",
        dlongitude: String(driverLocation?.lng || fromCoords.lng),
        dlatitude:  String(driverLocation?.lat || fromCoords.lat),
        bookingSno: userDetails?.ServiceNo || "",
        WorkArea: null, WorkScope: null, Priority: null,
        From: fromLocation.value,
        TO:   toLocation.value,
        Remark: "",
        SubBook: "I",
        BookingStatus: "S", // S = Scheduled Booking (not real-time)
      }];

      console.log("[AdvancedBookingForm] 📤 Sending booking payload:", JSON.stringify(payload, null, 2));

      const res = await api.post("/BookingRegister/PostForkBooking", payload);
      
      if (res.status === 200) {
        const { bookingForAlert, actualBookingId } = await processBookingResponse(res.data, payload, bookingDateTime);
       
        console.log("[AdvancedBookingForm] Actual bId from API:", actualBookingId);
        
        let driverName = selectedVehicle.driverName || selectedVehicle.driverSno || "Driver";
        try {
          const usersRes = await api.get("/User/GetUsers");
          const users = usersRes.data?.resultSet || usersRes.data || [];
          const driver = users.find(u => u.ServiceNo === selectedVehicle.driverSno);
          if (driver?.Name) driverName = driver.Name;
        } catch (err) {
          console.warn("Failed to fetch driver name:", err);
        }
        
        setSubmittedBooking({
          ...bookingForAlert,
          vehicleType: "Forklift",
          driverName: driverName,
          weightCat: selectedWeight,
          distance: "0",
          bookingTime: bookingDateTime,
          scheduledFor: bookingDateTime,
        });
        
        setShowBookingOverlay(true);
        toast.success(`Forklift booking scheduled for ${bookingDateTime}! Driver will be notified at that time.`);
        
        if (onBookingCreated) await onBookingCreated();
        
        setTimeout(() => {
          setShowBookingOverlay(false);
          if (onClose) onClose();
        }, 3000);
      }
    } catch (err) {
      console.error("[AdvancedBookingForm] Booking failed:", err);
      toast.error("Failed to create booking. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  // ── step visibility ───────────────────────────────────────────────────────

  const showStep2 = !!selectedWeight;
  const showStep3 = showStep2 && !!fromLocation && !!toLocation;
  const showStep4 = showStep3 && !!selectedVehicle;

  const selectPortalStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu:       (base) => ({ ...base, zIndex: 9999 }),
  };

  // ─────────────────────────────────────────────────────────────────────────

  return (
    <>
      <div className="w-full bg-gradient-to-br from-white to-blue-50 rounded-2xl shadow-xl p-6 md:p-8">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            Create Forklift Booking
          </h2>
          {onClose && (
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition"
            >
              <X size={28} />
            </button>
          )}
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* ── STEP 1: Weight Category ── */}
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">
                1
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                Select Weight Category
              </h3>
            </div>

            {loadingWeights || loadingVehicles ? (
              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600" />
                <span className="text-gray-600 text-sm">Loading weight categories...</span>
              </div>
            ) : weightOptions.length === 0 ? (
              <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700 text-sm">
                No weight categories available. Please check vehicle data.
              </div>
            ) : (
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
                {weightOptions.map((opt) => {
                  const count = forkliftVehicles.filter(
                    (v) => v.weightCat === opt.value && v.oStatus === "Online"
                  ).length;
                  const active = selectedWeight === opt.value;
                  return (
                    <button
                      key={opt.value}
                      type="button"
                      disabled={count === 0}
                      onClick={() => {
                        setSelectedWeight(opt.value);
                        setFromLocation(null);
                        setToLocation(null);
                        setSuggestedVehicles([]);
                        setSelectedVehicle(null);
                      }}
                      className={`relative flex flex-col items-center justify-center p-3 rounded-xl border-2 font-semibold text-sm transition
                        ${
                          count === 0
                            ? "opacity-40 cursor-not-allowed bg-gray-100 border-gray-200 text-gray-400"
                            : active
                            ? `${opt.color} ring-2 ring-offset-1 ring-blue-500 shadow-md scale-105`
                            : `${opt.color} hover:scale-105 hover:shadow cursor-pointer`
                        }`}
                    >
                      <Truck size={20} className="mb-1" />
                      {opt.label}
                      <span className={`text-xs mt-1 font-normal ${count === 0 ? "text-gray-400" : "opacity-70"}`}>
                        {count} available
                      </span>
                      {active && (
                        <CheckCircle
                          size={14}
                          className="absolute top-1 right-1 text-blue-600"
                        />
                      )}
                    </button>
                  );
                })}
              </div>
            )}
          </div>

          {/* ── STEP 2: Locations ── */}
          {showStep2 && (
            <div className="space-y-4 pt-4 border-t border-gray-200">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">
                  2
                </div>
                <h3 className="text-lg font-semibold text-gray-800">
                  Select Locations
                </h3>
              </div>

              {loadingWorkAreas ? (
                <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600" />
                  <span className="text-gray-600 text-sm">Loading locations...</span>
                </div>
              ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {/* From */}
                  <div>
                    <label className="block text-gray-800 font-bold mb-2 flex items-center gap-2 text-sm">
                      <MapPin className="text-green-600" size={18} />
                      From Location <span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={locationOptions}
                      value={fromLocation}
                      onChange={(opt) => {
                        setFromLocation(opt);
                        setSelectedVehicle(null);
                      }}
                      placeholder="Select starting location..."
                      isClearable
                      isSearchable
                      menuPortalTarget={document.body}
                      styles={selectPortalStyles}
                    />
                    {fromLocation && (
                      <p className="text-xs text-green-600 mt-1">
                        ✓ {fromLocation.label}
                      </p>
                    )}
                  </div>

                  {/* To */}
                  <div>
                    <label className="block text-gray-800 font-bold mb-2 flex items-center gap-2 text-sm">
                      <MapPin className="text-blue-600" size={18} />
                      To Location <span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={locationOptions.filter(
                        (o) => o.value !== fromLocation?.value
                      )}
                      value={toLocation}
                      onChange={(opt) => {
                        setToLocation(opt);
                        setSelectedVehicle(null);
                      }}
                      placeholder="Select destination..."
                      isClearable
                      isSearchable
                      menuPortalTarget={document.body}
                      styles={selectPortalStyles}
                    />
                    {toLocation && (
                      <p className="text-xs text-blue-600 mt-1">
                        ✓ {toLocation.label}
                      </p>
                    )}
                  </div>
                </div>
              )}

              {fromLocation && toLocation && (
                <div className="flex items-center justify-center gap-3 p-3 bg-blue-50 rounded-lg text-sm font-semibold text-gray-700">
                  <span>{fromLocation.label}</span>
                  <ArrowRight className="text-blue-600" size={18} />
                  <span>{toLocation.label}</span>
                </div>
              )}
            </div>
          )}

          {/* ── STEP 3: Suggested Vehicle ── */}
          {showStep3 && (
            <div className="space-y-3 pt-4 border-t border-gray-200">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">
                  3
                </div>
                <h3 className="text-lg font-semibold text-gray-800">
                  Suggested Forklift
                </h3>
              </div>

              {suggestedVehicles.length === 0 ? (
                <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700 text-sm">
                  No <strong>{selectedWeight}</strong> forklift available online. Please
                  choose a different weight category.
                </div>
              ) : (
                <>
                  <p className="text-xs text-gray-500">
                    Showing the best available <strong>{selectedWeight}</strong> forklift 
                    closest to <strong>{fromLocation?.label}</strong>
                  </p>
                  <div className="space-y-2">
                    {(() => {
                      const v = suggestedVehicles[0];
                      const isSelected = selectedVehicle?.vehicleId === v.vehicleId;
                      const vLat = parseFloat(
                        v.latitude || v.lat || v.currentLat || 0
                      );
                      const vLng = parseFloat(
                        v.longitude || v.lng || v.currentLng || 0
                      );
                      const dist =
                        fromLocation?.lat && fromLocation?.lng && vLat && vLng
                          ? haversineKm(
                              fromLocation.lat,
                              fromLocation.lng,
                              vLat,
                              vLng
                            ).toFixed(1)
                          : null;

                      return (
                        <button
                          key={v.vehicleId}
                          type="button"
                          onClick={() => setSelectedVehicle(v)}
                          className={`w-full flex items-center justify-between p-4 rounded-xl border-2 text-left transition
                            ${
                              isSelected
                                ? "border-green-500 bg-green-50 ring-2 ring-green-300"
                                : "border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50"
                            }`}
                        >
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm bg-amber-400 text-white">
                              ★
                            </div>
                            <div>
                              <p className="font-semibold text-gray-800">
                                {v.vehicleId}
                              </p>
                              <p className="text-xs text-gray-500">
                                {v.weightCat} · Driver: {v.driverSno}
                                {dist ? ` · ~${dist} km away` : ""}
                              </p>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <span
                              className={`text-xs px-2 py-0.5 rounded-full font-medium
                              ${
                                v.oStatus === "Online"
                                  ? "bg-green-100 text-green-700"
                                  : "bg-gray-100 text-gray-500"
                              }`}
                            >
                              {v.oStatus || v.status || "Available"}
                            </span>
                            {isSelected && (
                              <CheckCircle size={18} className="text-green-600" />
                            )}
                          </div>
                        </button>
                      );
                    })()}
                  </div>
                </>
              )}
            </div>
          )}

          {/* ── STEP 4: Schedule Booking ── */}
          {showStep4 && (
            <div className="space-y-4 pt-4 border-t border-gray-200">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">
                  4
                </div>
                <h3 className="text-lg font-semibold text-gray-800">
                  Schedule Booking
                </h3>
                <span className="text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full">
                  Planned Booking
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Date Field */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                    <CalendarIcon className="text-blue-600" size={18} />
                    Booking Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    min={todayStr}
                    readOnly
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-600 focus:outline-none"
                  />
                </div>

                {/* Time Field - Using CustomTimePicker */}
                <div>
                  <CustomTimePicker
                    label="Start Time"
                    value={bsTime}
                    onChange={handleTimeChange}
                    required={true}
                    error={timeError}
                    placeholder="HH:MM"
                  />
                   
                </div>
              </div>

              {/* Info message about scheduled booking */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-xs text-blue-700 flex items-center gap-2">
                  <CalendarIcon size={14} />
                  This is a <strong>scheduled/planned booking</strong>. The driver will receive an alert only at the selected start time, not immediately.
                </p>
              </div>
            </div>
          )}

          {/* ── Summary ── */}
          {showStep4 && bsTime && (
            <div className="bg-gradient-to-br from-blue-100 to-indigo-100 p-5 rounded-xl border-2 border-blue-300">
              <h4 className="font-semibold text-blue-900 mb-3">📋 Booking Summary</h4>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div>
                  <span className="text-blue-700 font-medium">Vehicle:</span>
                  <p className="text-gray-800 font-semibold">
                    {selectedVehicle.vehicleId}
                  </p>
                </div>
                <div>
                  <span className="text-blue-700 font-medium">Capacity:</span>
                  <p className="text-gray-800">{selectedVehicle.weightCat}</p>
                </div>
                <div>
                  <span className="text-blue-700 font-medium">Driver:</span>
                  <p className="text-gray-800">{selectedVehicle.driverSno}</p>
                </div>
                <div>
                  <span className="text-blue-700 font-medium">Date & Time:</span>
                  <p className="text-gray-800 font-semibold">
                    {selectedDate} {bsTime}
                  </p>
                </div>
                <div className="col-span-2">
                  <span className="text-blue-700 font-medium">Route:</span>
                  <p className="text-gray-800 flex items-center gap-2 flex-wrap">
                    <span>{fromLocation.label}</span>
                    <ArrowRight size={14} />
                    <span>{toLocation.label}</span>
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    Codes: {fromLocation.value} → {toLocation.value}
                  </p>
                </div>
                <div className="col-span-2 mt-2 pt-2 border-t border-blue-200">
                  <p className="text-xs text-blue-700 flex items-center gap-1">
                    <CalendarIcon size={12} />
                    <strong>Planned Booking:</strong> Driver will be notified on {selectedDate} at {bsTime}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* ── Buttons ── */}
          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-3 rounded-lg font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              disabled={
                !showStep4 || !bsTime || isSubmitting || timeError
              }
              className={`px-8 py-3 rounded-lg font-bold text-white transition
                ${
                  showStep4 && bsTime && !isSubmitting && !timeError
                    ? "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-lg"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
            >
              {isSubmitting ? "Creating Booking..." : "Schedule Forklift Booking"}
            </button>
          </div>
        </form>
      </div>

      {/* Booking Success Overlay */}
      {showBookingOverlay && submittedBooking && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center px-4 z-50 animate-fadeIn">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 relative animate-slideUp">
            <button
              onClick={() => {
                setShowBookingOverlay(false);
                if (onClose) onClose();
              }}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">
              Forklift Booking Scheduled!
            </h2>
            <p className="text-center text-gray-600 mb-6">
              Driver will be notified at the scheduled time
            </p>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 space-y-3 mb-6">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Booking ID:</span>
                <span className="font-bold text-blue-700">
                  #{submittedBooking.bId || "Pending"}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Scheduled For:</span>
                <span className="font-semibold text-blue-700">
                  {submittedBooking.scheduledFor || submittedBooking.bookingTime}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Vehicle:</span>
                <span className="font-semibold text-gray-800">
                  {submittedBooking.vehicleType} ({submittedBooking.weightCat})
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Driver:</span>
                <span className="font-semibold text-gray-800">
                  {submittedBooking.driverName}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Route:</span>
                <span className="font-semibold text-gray-800 text-sm truncate max-w-[200px]">
                  {submittedBooking.From} → {submittedBooking.TO}
                </span>
              </div>
            </div>

            <div className="flex justify-center items-center space-x-2 mb-4">
              <CalendarIcon size={16} className="text-blue-600" />
              <span className="text-sm text-gray-500">
                Alert will be sent at scheduled time
              </span>
            </div>

            <p className="text-center text-sm text-gray-500">
              Closing in a moment...
            </p>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
    </>
  );
}